import { render } from "./amsLogin.vue?vue&type=template&id=deeb7152"
import script from "./amsLogin.vue?vue&type=script&lang=js"
export * from "./amsLogin.vue?vue&type=script&lang=js"

import "./amsLogin.vue?vue&type=style&index=0&id=deeb7152&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__